import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { get, post, put } from "../../../../../controlers/global/ConfigRequest";
import {
    ADD_USER_COMPANY,
    EDIT_USER_COMPANY,
    GET_ONE_USER_COMPANY,
} from "../../../../../helperData/ApiAddress";
import DatePickerModal from "../../../../../component/global/DatePicker";
import { ToastContext } from "../../../../../component/global/ToastContext";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment-jalaali";
import { useTranslation } from "react-i18next";

export default function AddUser({
    hideModal,
    changeRefreshValue,
    editMode,
    itemId,
}) {
    const [name, setName] = useState("");
    const [lName, setLname] = useState("");
    const [city, setCity] = useState("");
    const [education, setEducation] = useState("0");
    const [email, setEmail] = useState("");
    const [gender, setGender] = useState("0");
    const [callInfo, setCallInfo] = useState("");
    const [birthDatePicker, setBirthDatePicker] = useState(false);
    const [birthDate, setBirthDate] = useState({
        fa: "1390-01-01",
        en: "2000-01-01",
    });
    const [spLoader, setSpLoader] = useState(false);
    const [editLoader, setEditLoader] = useState(false);
    const { t } = useTranslation();

    const show = useContext(ToastContext);

    const [error, setError] = useState({
        errName: "",
        errLname: "",
        errBirthDate: "",
        errEducation: "",
        errEmail: "",
        errGender: "",
        errCallInfo: "",
    });

    const HandleFormError = (e) => {
        let errors = {
            errName: "",
            errLname: "",
            errBirthDate: "",
            errCity: "",
            errEducation: "",
            errEmail: "",
            errGender: "",
            errCallInfo: "",
            errUsername: "",
            errPassword: "",
        };

        let patt = new RegExp(/^\?([0-9]*)$/);

        let mailPatt = new RegExp(
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        );

        if (!mailPatt.test(email)) {
            errors.errEmail = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.Validation.Email"
            );
        }

        if (name === "") {
            errors.errName = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errName"
            );
        }
        if (lName === "") {
            errors.errLname = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errLname"
            );
        }
        if (birthDate === "") {
            errors.errBirthDate = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errBirthDate"
            );
        }
        if (city === "") {
            errors.errCity = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errCity"
            );
        }
        if (education === "") {
            errors.errEducation = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errEducation"
            );
        }
        if (email === "") {
            errors.errEmail = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errEmail"
            );
        }
        if (gender === "") {
            errors.errGender = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errGender"
            );
        }
        if (callInfo === "") {
            errors.errCallInfo = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errCallInfo"
            );
        }

        if (patt.test(callInfo)) {
            errors.errCallInfo = t(
                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.errors.errInvalidCallInfo"
            );
        }

        setError(errors);

        if (Object.values(errors).every((elem) => elem === "")) {
            return true;
        }

        return false;
    };

    const fetchOneCustomer = () => {
        if (editMode) {
            setEditLoader(true);
            get(GET_ONE_USER_COMPANY.replace("{id}/", itemId)).then((r) => {
                setName(r.user?.first_name);
                setLname(r.user?.last_name);
                setCity(r.user?.city);
                setEducation(r.user?.education);
                setEmail(r.user?.email);
                setGender(r.user?.sex);
                setCallInfo(r.user?.phone_number);
                setBirthDate({
                    fa: moment(r.user?.birthDate).format("jYYYY/jMM/jDD"),
                    en: r.user?.birthDate,
                });
                setEditLoader(false);
            });
        }
    };

    const sendUserData = (e) => {
        e.preventDefault(e);
        let result = HandleFormError();
        if (result) {
            setSpLoader(true);
            post(ADD_USER_COMPANY, {
                first_name: name,
                last_name: lName,
                birthday: birthDate.en,
                city: city,
                education: 1,
                email: email,
                sex: 1,
                phone_number: callInfo,
                club_level: 1,
            })
                .then((r) => {
                    console.log(r);
                    if (r.status === 400) {
                        show(
                            t(
                                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.User.Danger"
                            ),
                            "danger"
                        );
                    } else {
                        show(
                            t(
                                "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.User.Success"
                            ),
                            "success"
                        );
                        setSpLoader(false);
                        hideModal();
                        changeRefreshValue();
                    }
                })
                .catch((r) => {
                    show(
                        t(
                            "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.User.Danger"
                        ),
                        "danger"
                    );
                    setSpLoader(false);
                });
        }
    };

    const sendEditedUserData = (e) => {
        e.preventDefault(e);
        let result = HandleFormError();
        if (result) {
            setSpLoader(true);
            put(EDIT_USER_COMPANY.replace("{id}", itemId), {
                first_name: name,
                last_name: lName,
                birthday: birthDate.en,
                city: city,
                education: 1,
                email: email,
                sex: 1,
                phone_number: callInfo,
                club_level: 1,
            })
                .then((r) => {
                    show(
                        t(
                            "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.EditUser.Sucesss"
                        ),
                        "success"
                    );
                    setSpLoader(false);
                    hideModal();
                    changeRefreshValue();
                })
                .catch(() => {
                    show(
                        t(
                            "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AddUser.EditUser.Danger"
                        ),
                        "danger"
                    );
                    setSpLoader(false);
                    hideModal();
                });
        }
    };

    useEffect(() => {
        fetchOneCustomer();
    }, [editMode]);

    if (editLoader) {
        return (
            <div className="edit-mode-loader">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                </Spinner>
            </div>
        );
    }

    return (
        <div>
            <form className="new-user-form">
                <Form.Group controlId="formName">
                    <Form.Label>
                        {t("Organizational.CustomerClub.Name.Place.Holder")}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="مثال : نیما"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className={error.errName && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: error.errName ? "block" : "none",
                        }}
                    >
                        {error.errName}
                    </div>
                </Form.Group>
                <Form.Group controlId="formLname">
                    <Form.Label>
                        {t("Organizational.CustomerClub.LastName.Place.Holder")}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="مثال : نیما"
                        value={lName}
                        onChange={(e) => setLname(e.target.value)}
                        className={error.errLname && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: error.errLname ? "block" : "none",
                        }}
                    >
                        {error.errLname}
                    </div>
                </Form.Group>
                <div>
                    <Form.Group controlId="formBasicBday">
                        <Form.Label>
                            {t(
                                "Organizational.CustomerClub.BirthDate.Place.Holder"
                            )}
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="مثال : نیما"
                            onChange={(e) => setBirthDate(e.target.value)}
                            className={error.errBirthDate && "input-error"}
                            value={birthDate.fa}
                            onClick={(e) => setBirthDatePicker(true)}
                            readOnly
                        />
                        <div
                            className="error"
                            style={{
                                display: error.errBirthDate ? "block" : "none",
                            }}
                        >
                            {error.errBirthDate}
                        </div>
                    </Form.Group>
                    <DatePickerModal
                        show={birthDatePicker}
                        close={setBirthDatePicker}
                        defaultValue={birthDate.fa}
                        onChange={setBirthDate}
                    />
                </div>
                <Form.Group controlId="formCity">
                    <Form.Label>
                        {t(
                            "Organizational.CustomerClub.PlaceOfLiving.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="مثال : نیما"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        className={error.errCity && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: error.errCity ? "block" : "none",
                        }}
                    >
                        {error.errCity}
                    </div>
                </Form.Group>
                <Form.Group controlId="formEducation">
                    <Form.Label>تحصیلات</Form.Label>
                    <div>
                        <select
                            value={education}
                            name="education"
                            id="education"
                            className="add-user-select"
                            onChange={(e) => setEducation(e.target.value)}
                        >
                            <option value="" disabled selected name="">
                                {t(
                                    "Organizational.CustomerClub.Degree.Drop.Filter"
                                )}
                            </option>
                            <option value="1" name="1">
                                {t(
                                    "Organizational.CustomerClub.Degree.Diploma.Drop.Filter"
                                )}
                            </option>
                            <option value="2" name="2">
                                {t(
                                    "Organizational.CustomerClub.Degree.Bachelor's.Drop.Filter"
                                )}
                            </option>
                            <option value="3" name="3">
                                {t(
                                    "Organizational.CustomerClub.Degree.Master's.Drop.Filter"
                                )}
                            </option>
                            <option value="4" name="4">
                                {t(
                                    "Organizational.CustomerClub.Degree.PhD.Drop.Filter"
                                )}
                            </option>
                        </select>
                    </div>
                    <div
                        className="error"
                        style={{
                            display: error.errEducation ? "block" : "none",
                        }}
                    >
                        {error.errEducation}
                    </div>
                </Form.Group>
                <Form.Group controlId="formEmail">
                    <Form.Label>
                        {t("Organizational.CustomerClub.Email.Place.Holder")}
                    </Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="مثال : نیما"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={error.errEmail && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: error.errEmail ? "block" : "none",
                        }}
                    >
                        {error.errEmail}
                    </div>
                </Form.Group>
                <Form.Group controlId="formGender">
                    <Form.Label>
                        {t("Organizational.CustomerClub.Gender.Drop.Filter")}
                    </Form.Label>
                    <div>
                        <select
                            value={gender}
                            name="gender"
                            id="gender"
                            className="add-user-select"
                            onChange={(e) => setGender(e.target.value)}
                        >
                            <option value="" disabled selected name="">
                                {t(
                                    "Organizational.CustomerClub.Gender.Drop.Filter"
                                )}
                            </option>
                            <option value="1">
                                {t(
                                    "Organizational.CustomerClub.GenderMale.Drop.Filter"
                                )}
                            </option>
                            <option value="2">
                                {t(
                                    "Organizational.CustomerClub.GenderFemale.Drop.Filter"
                                )}
                            </option>
                        </select>
                    </div>
                    <div
                        className="error"
                        style={{
                            display: error.errGender ? "block" : "none",
                        }}
                    >
                        {error.errGender}
                    </div>
                </Form.Group>

                <Form.Group controlId="formCallNum">
                    <Form.Label>
                        {t(
                            "Organizational.CustomerClub.PhoneNumber.Place.Hodler"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="tell"
                        placeholder="مثال : نیما"
                        value={callInfo}
                        onChange={(e) => setCallInfo(e.target.value)}
                        className={error.errCallInfo && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: error.errCallInfo ? "block" : "none",
                        }}
                    >
                        {error.errCallInfo}
                    </div>
                </Form.Group>
                <div className="btn-group">
                    <button
                        className="blue send-bt-style"
                        onClick={editMode ? sendEditedUserData : sendUserData}
                    >
                        {spLoader && (
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden"></span>
                            </Spinner>
                        )}
                        <div>
                            {t("Organizational.CustomerClub.Send.Button")}
                        </div>
                    </button>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            hideModal();
                        }}
                        className=" red"
                    >
                        {t("Organizational.CustomerClub.Cancel.Button")}
                    </button>
                </div>
            </form>
        </div>
    );
}
